import React, { useEffect, useRef, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { CustomAdvancedMenuList, CustomDialog } from '../../../components/StyledComponents';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ControlpanelErrorButton, ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelSuccessButton, GrayIconButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomSelect from '../../../components/CustomSelect';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CustomDatePicker from '../../../components/CustomDatePicker';
import { useAuth } from '../../../context/AuthContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import Webcam from "react-webcam";
import CustomTimePicker from '../../../components/CustomTimePickerHaveSecond';
import SaveIcon from '@mui/icons-material/Save';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const EditEventLogDialog = ({ id, onClose, refreshData, handleRefreshData, refresh }) => {
    const [show, hide] = useLoading();
    const { t } = useTranslation();
    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const [openCamera, setOpenCamera] = useState(false);
    const webcamRef = useRef(null);

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenCamera(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const initialFormData = {
        fullName: '',
        eventType: '',
        timeGMT: '',
        selectDate: null,
        selectTime: null,
        langId: localStorage.getItem("i18nextLngId")
    };

    const [formData, setFormData] = useState(initialFormData);

    const [validationMessages, setValidationMessages] = useState({
        fullName: '',
        eventType: '',
        timeGMT: '',
        selectDate: '',
        selectTime: '',
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    const handleCloseDialog = () => {
        setFormData(initialFormData);
        onClose();
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }
    };

    const handleSubmit = async () => {
        if (!formData.fullName || !formData.eventType || !formData.selectDate || !formData.selectTime) {
            toast.error(t("common.fill-required"));
            return;
        }

        const date = dayjs(formData.selectDate).format("YYYY-MM-DD");

        const dateTimeLocal = `${date} ${formData.selectTime}`;

        // 👉 convert về UTC ISO
        const timeGMT = dayjs(dateTimeLocal).utc().toISOString();

        const payload = {
            ...formData,
            timeGMT,
        };

        toast.success(t("common.add-success"));

        setFormData(initialFormData);
        onClose();
        handleRefreshData?.();
    };

    const fileInputRef = useRef(null);

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    const handleReject = () => {
        toast.success(t("common.reject-success"));
        onClose();
    }

    const handleApprove = () => {
        toast.success(t("common.approve-success"));
        onClose();
    }

    return (
        <>
            <CustomDialog maxWidth={'md'} open onClose={handleCloseDialog} keepMounted>
                <DialogTitle>
                    <div className='flex justify-between'>
                        <div className='flex items-center gap-4'>
                            <p className='text-xl font-semibold '>{t('common.edit-event')}</p>
                        </div>
                        <GrayIconButton onClick={handleCloseDialog}>
                            <CloseIcon />
                        </GrayIconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className='space-y-4 mt-4'>
                        <div className=''>
                            <p>{t('common.event-type')}<span className='text-[#EF4444] ml-1'>*</span></p>
                            <FormControl
                                component='fieldset'
                                sx={{
                                    '.MuiFormGroup-root.MuiFormGroup-row': {
                                        gap: '20px',
                                    },
                                }}
                            >
                                <RadioGroup row aria-label='Event type' name='eventType' value={formData.eventType} onChange={handleInputChange}>
                                    <FormControlLabel value={"CHECK_IN"} control={<Radio size='small' />} label={t('attendance.CHECK_IN')} />
                                    <FormControlLabel value={"CHECK_OUT"} control={<Radio size='small' />} label={t('attendance.CHECK_OUT')} />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div>
                            <label>{t('common.name')} <span className="text-red-500">*</span></label>
                            <CustomInput name='fullName' value={formData.fullName} handleInputChange={handleInputChange} disabled readOnly={true} />
                        </div>

                        <div className='col-span-12 md:col-span-6 mt-4'>
                            <label>{t('common.select-date')}</label>
                            <CustomDatePicker
                                name='selectDate'
                                value={formData.selectDate}
                                onChange={(newDate) => handleDataChange('selectDate', newDate)}
                                readOnly={true}
                                className='!mt-2'
                                dateFormat={genaralSettingDateFormat}
                            />
                        </div>
                        <div className='col-span-12 md:col-span-6'>
                            <label>{t('common.select-time')}</label>
                            <CustomTimePicker
                                hoursLabel={false}
                                secondsEnabled={false}
                                readOnly={false}
                                onTimeChange={(time) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        selectTime: time,
                                    }))
                                }
                                value={formData.selectTime}
                                name='selectTime'
                                maxHours={23}
                                className='!mt-2'
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='flex gap-2 px-4 py-4'>
                        <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                            <CloseIcon />
                            <p>{t('button.cancel')}</p>
                        </ControlpanelSecondaryButton>

                        <ControlpanelPrimaryButton onClick={(e) => {
                            handleSubmit()
                        }}>
                            <SaveIcon />
                            <p>{t('button.save-changes')}</p>
                        </ControlpanelPrimaryButton>
                    </div>
                </DialogActions>
            </CustomDialog>
        </>
    )
}

export default EditEventLogDialog